import { AwardIcon, Navigation2Icon, SailboatIcon, UsersIcon } from "lucide-react";
import type { CrewListMember, MetricPill } from "./crew.types";

export function buildMetrics(members: CrewListMember[]): MetricPill[] {
  const atSea = members.filter((m) => m.user.crewMemberships.some((cm) => cm.expedition.status === "ACTIVE")).length;
  const totalMiles = members.reduce((s, m) => s + m.user.totalMilesLogged, 0);
  const milesLabel = totalMiles >= 1000 ? `${(totalMiles / 1000).toFixed(1)}k nm` : `${totalMiles} nm`;
  return [
    { label: "Total", value: String(members.length), Icon: UsersIcon, color: "text-abyss-500" },
    { label: "At sea", value: String(atSea), Icon: SailboatIcon, color: "text-shallow-500" },
    { label: "Certificates", value: "—", Icon: AwardIcon, color: "text-signal-600" },
    { label: "Total miles", value: milesLabel, Icon: Navigation2Icon, color: "text-violet-500" },
  ];
}
